import { Component, Input } from '@angular/core';

@Component({
  selector: 'percentage-container',
  templateUrl: 'percentage-container.component.html',
  styleUrls: ['percentage-container.component.scss'],
  standalone: false
})
export class PercentageContainerComponent {
  @Input()
  label: string;
  @Input()
  percentage: number;
  @Input()
  count: number;
  @Input()
  isOnTeams: boolean;
  @Input()
  click: any;
  @Input()
  disableTooltip: boolean = true;

  doClick() {
    if (this.click) {
      this.click();
    }
  }
}
